import register from '../../../../global/js/registry';
export default register('m-kb-navbar', () => import(/* webpackMode: "lazy" */ './m-kb-navbar.controller'));
